import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useEcuStore } from '../../stores/ecuStore';
import FaqSkeleton from '../main/faq/faqSkeleton';

export const SupportedTypes: React.FC = () => {
    const { ecus, fetchEcu } = useEcuStore();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            try {
                await fetchEcu();
            } finally {
                setIsLoading(false);
            }
        };
        loadData();
    }, []);

    return (
        <div className="w-full text-center mt-10">

            {isLoading ? (
                <FaqSkeleton itemsCount={5} />
            ) : ecus ? (
                <>
                    <h2 className="text-xl font-bold mb-6">{t("Supported ECU types")}</h2>

                    <div className="flex max-md:flex-wrap md:flex-row justify-evenly ">
                        {ecus.map((group, index) => (
                            <div
                                key={index}
                                className="w-3/4 md:w-auto"
                            >

                                <h3 className="font-bold mb-2 text-primary">
                                    {group.title}
                                </h3>

                                <ul className="space-y-1 text-left">
                                    {group.models.map((model, modelIndex) => (
                                        <li
                                            key={modelIndex}
                                        >
                                            <span className="font-mono text-textsecondary">{model}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <p>NO ECU INFO</p>
            )}

        </div>
    );
};